import { cn } from "@/lib/utils";

type Step = "cart" | "shipping" | "review";

interface CheckoutBreadcrumbProps {
  currentStep: Step;
}

export function CheckoutBreadcrumb({ currentStep }: CheckoutBreadcrumbProps) {
  const stepOrder: Step[] = ["cart", "shipping", "review"];
  const currentIndex = stepOrder.indexOf(currentStep);

  const getStepClassName = (stepKey: Step) => {
    const stepIndex = stepOrder.indexOf(stepKey);
    if (stepIndex === currentIndex) return "active";
    if (stepIndex < currentIndex) return "completed";
    return "";
  };

  return (
    <nav className="checkout-breadcrumb mb-6">
      <span
        className={cn("checkout-breadcrumb-item", getStepClassName("cart"))}
      >
        Cart
      </span>
      <svg
        className="w-4 h-4 text-(--color-text-placeholder)"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5l7 7-7 7"
        />
      </svg>
      <span
        className={cn("checkout-breadcrumb-item", getStepClassName("shipping"))}
      >
        Shipping
      </span>
      <svg
        className="w-4 h-4 text-(--color-text-placeholder)"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5l7 7-7 7"
        />
      </svg>
      <span
        className={cn("checkout-breadcrumb-item", getStepClassName("review"))}
      >
        Review
      </span>
      <svg
        className="w-4 h-4 text-(--color-text-placeholder)"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5l7 7-7 7"
        />
      </svg>
      <span className="checkout-breadcrumb-item">Payment</span>
    </nav>
  );
}
